export default __webpack_public_path__ + "static/media/README.0538216a.md";